import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/configHostSuffix/upsert/uptime.configHostSuffix.upsert.mutation.gql"
import { UPTIME_CONFIG_REFETCH_QUERIES } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import type {
  UptimeConfigHostSuffixUpsertMutation,
  UptimeConfigHostSuffixUpsertMutationVariables,
} from "@/v2-backoffice-client/uptime/configHostSuffix/upsert/__types__/uptime.configHostSuffix.upsert.mutation"

type Options = MutationHookOptions<
  UptimeConfigHostSuffixUpsertMutation,
  UptimeConfigHostSuffixUpsertMutationVariables
>

export function useUptimeConfigHostSuffixUpsertMutation(options?: Options) {
  return useMutation<
    UptimeConfigHostSuffixUpsertMutation,
    UptimeConfigHostSuffixUpsertMutationVariables
  >(mutation, {
    refetchQueries: [...UPTIME_CONFIG_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
